import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FIELDS_FRAGMENT } from "constants/suggestions";

export const SEARCH_MODULES_SUGGESTIONS = gql`
  query SearchModulesSuggestions($input: SearchSuggestionsInput!) {
    searchModulesSuggestions(input: $input) {
      ...SearchSuggestionsFieldsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FIELDS_FRAGMENT}
`;

export const SEARCH_MODULES = gql`
  query SearchModules($input: SearchInput!) {
    searchModules(input: $input) {
      edges {
        cursor
        node {
          id
          administrative
          apiHost
          branch
          description
          canWrite
          isDisabled
          createdAt
          labels
          name
          namespace
          projectRoot
          provider
          repository
          terraformProvider
          moduleSource
          current {
            id
            number
            state
            yanked
            yankNote
          }
          spaceDetails {
            id
            name
            accessLevel
          }
          starred
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
`;
